import { render } from "./MahjBody.vue?vue&type=template&id=439de5b6&scoped=true"
import script from "./MahjBody.vue?vue&type=script&lang=js"
export * from "./MahjBody.vue?vue&type=script&lang=js"

import "./MahjBody.vue?vue&type=style&index=0&id=439de5b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439de5b6"]])

export default __exports__